import { render, staticRenderFns } from "./modal-collect-commission.vue?vue&type=template&id=8a31dcb8&scoped=true"
import script from "./modal-collect-commission.vue?vue&type=script&lang=js"
export * from "./modal-collect-commission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a31dcb8",
  null
  
)

export default component.exports